const env = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {};

export const IS_PROD = env.PROD === true || env.MODE === 'production';

function trimSlashes(s) {
  return (s || '').replace(/\/+$/, '');
}

/** Same-origin API prefix, always `/…` (e.g. `/api/v1`). */
function normalizeApiPrefix(raw) {
  const inner = trimSlashes(raw || '').replace(/^\/+/, '');
  return inner ? `/${inner}` : '';
}

/**
 * Path segment(s) for SNF API on the **same host** as the SPA (nginx/Vite proxies `/api…`).
 * `VITE_PUBLIC_*` is the canonical name; legacy `VITE_SNF_*` still works.
 * Default: `api/v1`.
 */
const apiPathRaw =
  env.VITE_PUBLIC_SNF_API_BASE_PATH ||
  env.VITE_SNF_API_BASE_PATH ||
  'api/v1';

export const SNF_API_BASE_PATH = normalizeApiPrefix(apiPathRaw);

/**
 * Browser base URL for SNF HTTP calls — always same-origin + prefix above.
 * (`VITE_PUBLIC_SNF_API_URL` is only for the dev-server proxy in `vite.config.js`, not embedded here.)
 */
export const SNF_API_BASE_URL = SNF_API_BASE_PATH;

export const MATOMO_URL = env.VITE_PUBLIC_MATOMO_URL || env.VITE_MATOMO_URL || '';

/** Matomo site id from env (string or number in bundle). */
export const MATOMO_SITE_ID = env.VITE_PUBLIC_MATOMO_SITE_ID ?? env.VITE_MATOMO_SITE_ID ?? '';
